import React from 'react';
// own
import { Attachment } from '../../../../../..';
import AttachmentPreviewSection from '../shared/AttachmentPreviewSection';
import { DialogContentProps } from '../..';
import AttachmentDetailsSection from './components/AttachmentDetailsSection';

const DesktopView = <T extends Attachment, >({ activeAttachment, handleClose, AttachmentDetails }: DialogContentProps<T>) => {
  return (
    <>
      <AttachmentPreviewSection attachment={activeAttachment} />
      <AttachmentDetailsSection
        handleClose={handleClose}
        activeAttachment={activeAttachment}
        AttachmentDetails={AttachmentDetails}
      />
    </>
  );
};

export default DesktopView;